import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Platform: [
      { name: 'Features', href: '/features' },
      { name: 'How It Works', href: '/how-it-works' },
      { name: 'Problems We Solve', href: '/problems' },
      { name: 'Technology', href: '/technology' },
    ],
    Company: [
      { name: 'About Us', href: '/about' },
      { name: 'Our Vision', href: '/about#vision' },
      { name: 'Contact Us', href: '/#register' },
      { name: 'Careers', href: '/careers' },
    ],
    Resources: [
      { name: 'Design Consultation', href: '/design-consultation' },
      { name: 'AR Platform Beta', href: '#' },
      { name: 'Blog', href: '/blog' },
      { name: 'FAQs', href: '/faqs' },
    ],
    Legal: [
      { name: 'Privacy Policy', href: '/privacy-policy' },
      { name: 'Terms of Service', href: '/terms-of-service' },
      { name: 'Cookie Policy', href: '/cookie-policy' },
      { name: 'Disclaimer', href: '/disclaimer' },
    ],
  };

  return (
    <footer id="contact" className="relative bg-[#F8F9FA] border-t border-[#E0E0E0] py-16 px-6 md:px-[7.6923%]">
      <div className="max-w-7xl mx-auto">
        {/* Top section */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_4717bcb5-d9a7-4674-a599-40a9fbf140e2/artifacts/vs2fmn5w_logo.png"
              alt="Immersid Logo"
              className="h-10 object-contain mb-6"
            />
            <p className="text-base mb-6 text-[#4A4A4A] leading-relaxed">
              Transforming how interior design, property development, and real-world spaces are
              imagined, experienced, and built.
            </p>

            {/* Contact info */}
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <Phone size={18} color="#FF8000" className="mt-1 flex-shrink-0" />
                <span className="text-sm text-[#4A4A4A]">
                  +6016-331 8826
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Mail size={18} color="#FF8000" className="mt-1 flex-shrink-0" />
                <span className="text-sm text-[#4A4A4A]">
                  enquiry@immersid.com
                </span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin size={18} color="#FF8000" className="mt-1 flex-shrink-0" />
                <span className="text-sm text-[#4A4A4A]">
                  Unit 1104A, 11/F, Kai Tak Commercial Building,<br />
                  No. 317-319 Des Voeux Road, Central, Hong Kong
                </span>
              </div>
            </div>
          </div>

          {/* Links */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4
                className="text-base font-semibold mb-4 text-[#1A1A1A]"
              >
                {category}
              </h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-sm text-[#808080] hover:text-[#FF8000] transition-colors duration-300"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div
          className="pt-8 border-t border-[#E0E0E0] flex flex-col md:flex-row justify-between items-center gap-4"
        >
          <p className="text-sm text-[#808080]">
            © {currentYear} Immersid Limited. All rights reserved.
          </p>

          {/* Social links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com/immersid/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border-2 border-[#E0E0E0] rounded-full flex items-center justify-center transition-all duration-300 hover:border-[#FF8000] hover:bg-[rgba(255,128,0,0.1)]"
              aria-label="Instagram"
              data-testid="social-instagram"
            >
              <Instagram size={18} color="#4A4A4A" />
            </a>
            <a
              href="https://www.facebook.com/immersid/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border-2 border-[#E0E0E0] rounded-full flex items-center justify-center transition-all duration-300 hover:border-[#FF8000] hover:bg-[rgba(255,128,0,0.1)]"
              aria-label="Facebook"
              data-testid="social-facebook"
            >
              <Facebook size={18} color="#4A4A4A" />
            </a>
            <a
              href="https://www.linkedin.com/company/immersid/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 border-2 border-[#E0E0E0] rounded-full flex items-center justify-center transition-all duration-300 hover:border-[#FF8000] hover:bg-[rgba(255,128,0,0.1)]"
              aria-label="LinkedIn"
              data-testid="social-linkedin"
            >
              <Linkedin size={18} color="#4A4A4A" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
